import React from "react";
import ImgAcrobat from "../../assets/Adobe.png"
import api from "../../services/api";
import {useState, useEffect} from 'react';

function ListaCertificado(){
  
    let [dados,setdados] = useState([])


    async function CarregaDocto()
    {
        const resultado = await api.get('/lstPdfEmp/?p=M');
        console.log(resultado)
        
        setdados(resultado.data)       

    }

    useEffect(()=>{
          CarregaDocto()
    },[]  );

   return<> 

            <div className="row">   
                                
            { dados.map(function(dado){
                                return       <div className="col-md-4">
                                <div className="card">
                                    <div className="card-header text-center">
                                           <img className="mt-1" src={ImgAcrobat} alt='Dant' style={{ height: "22px", margin: "22px" }}/>                                             
                                           <a href={dado.Arquivo}  target="_blank"> {dado.NomeRelatorio} </a>   
                                    </div>
                                                                   
                                 </div>
                            </div>
                         })

                         }      
             </div>    

</>

}

export default ListaCertificado;
